import { Open_Sans } from 'next/font/google';

const font = Open_Sans({
  weight: ['400', '600', '700', '800'],
  subsets: ['latin'],
  display: 'swap',
});

export const typography = {
  font,
};
